export default __webpack_public_path__ + "static/media/tutorial4-3.3cdfa3cc.png";